import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getOrderStatistic = createAsyncThunk('statistic/getOrder',
  async ({ dateFrom, dateTo, statuses } = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/statistic/orders', {
        params: {
          dateFrom,
          dateTo,
          statuses
        }
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getOrderStatistic;
